import React from "react";
import "./WhyChooseHome.css";
import { handleContactRedirect } from "../../handleContactRedirect";
import { useNavigate } from "react-router-dom";

const WhyChooseHome = () => {
  const navigate = useNavigate();
  return (
    <div className="whychooseus standard-padding">
      {/* <h2 className="heading whychooseus-heading">
        Why We're the B2B Travel Partner Businesses Trust
      </h2> */}

      <div className="whychooseus-container">
        {/* LEFT IMAGE */}
        <div className="whychooseus-left">
          <img
            src="https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/Figma%20Images/Why%20We're%20the%20B2B%20Travel.webp"
            alt="Handshake"
            className="whychooseus-img"
          />
        </div>

        {/* RIGHT CONTENT */}
        <div className="whychooseus-right">
          <h1 className="heading whychooseus-title">
            Why Are We the Right B2B Travel Partner?
          </h1>

          <p className="text whychooseus-desc">
            From availability checks to final execution, every detail is managed with structured coordination, reliable suppliers, and consistent follow-ups.
          </p>

          {/* FEATURES */}
          <div className="whychooseus-features">
            <div className="feature-item">
              <img
                src="/assets/icon1.png"
                alt=""
                className="icon"
              />
              <div>
                <h4>Verified Supplier Network </h4>
                <p>We work with pre-vetted hotels, transport, and local operators across destinations. </p>
              </div>
            </div>

            <div className="feature-item">
              <img
                src="/assets/icon2.png"
                alt=""
                className="icon"
              />
              <div>
                <h4>Active Booking Co-ordination </h4>
                <p>No booking goes untracked — we follow up and reconfirm every detail before arrival . </p>
              </div>
            </div>

            <div className="feature-item">
              <img
                src="/assets/icon3.png"
                alt=""
                className="icon"
              />
              <div>
                <h4>Fast, Practical Responses </h4>
                <p>Quick replies with workable solutions you can act on. </p>
              </div>
            </div>

            <div className="feature-item">
              <img
                src="/assets/icon4.png"
                alt=""
                className="icon"
              />
              <div>
                <h4>Multi-Destination Handling </h4>
                <p>From the UAE to Asia and Africa, one expert team handles every itinerary.</p>
              </div>
            </div>
          </div>

          {/* STATS */}
          <div className="whychooseus-stats">
            <div>
              <h3>40+</h3>
              <p>Countries</p>
            </div>
            <div>
              <h3>15k+</h3>
              <p>Clients</p>
            </div>
            <div>
              <h3>$480M</h3>
              <p>Turnover</p>
            </div>
            <div>
              <h3>220+</h3>
              <p>Awards</p>
            </div>
          </div>

          {/* BUTTON */}
            <button  onClick={() => handleContactRedirect(navigate)} className="whychooseus-btn">Request a Quote</button>
        </div>
      </div>
    </div>
  );
};

export default WhyChooseHome;
